// Robust geolocation helper used when starting a job ("Dar andamento").
// Mobile browsers (especially iOS PWA) frequently time out or fail silently
// when using { enableHighAccuracy: true } with a short timeout. This helper
// tries a high-accuracy fix first and falls back to a faster low-accuracy
// attempt, and returns clear, actionable error messages per error code.

function messageForGeoError(err) {
  if (!err || typeof err.code === "undefined") {
    return "Não foi possível obter sua localização. Tente novamente.";
  }
  switch (err.code) {
    case 1: // PERMISSION_DENIED
      return (
        "Permissão de localização negada. Ative o GPS do aparelho e permita o " +
        "acesso à localização para este site nas configurações do navegador."
      );
    case 2: // POSITION_UNAVAILABLE
      return (
        "Não foi possível obter sua localização. Verifique se o GPS do aparelho " +
        "está ligado e tente novamente em um local aberto."
      );
    case 3: // TIMEOUT
      return (
        "A busca pela localização demorou demais. Verifique seu sinal/GPS e " +
        "tente novamente."
      );
    default:
      return err.message || "Não foi possível obter sua localização.";
  }
}

function toCoords(pos) {
  return { lat: pos.coords.latitude, lng: pos.coords.longitude };
}

// Returns a Promise resolving to { lat, lng } or rejecting with a friendly Error.
export function getCurrentCoords() {
  return new Promise((resolve, reject) => {
    if (!("geolocation" in navigator)) {
      reject(new Error("GPS indisponível neste dispositivo."));
      return;
    }
    if (window.isSecureContext === false) {
      reject(
        new Error(
          "A localização exige uma conexão segura (HTTPS). Abra o sistema pelo " +
            "endereço oficial e tente novamente.",
        ),
      );
      return;
    }

    const fail = (err) => reject(new Error(messageForGeoError(err)));

    // Fallback: lower accuracy, longer timeout, allow a recent cached fix.
    const tryLowAccuracy = () => {
      navigator.geolocation.getCurrentPosition(
        (pos) => resolve(toCoords(pos)),
        fail,
        { enableHighAccuracy: false, timeout: 20000, maximumAge: 60000 },
      );
    };

    // First attempt: high accuracy, allow a short cached fix to speed things up.
    navigator.geolocation.getCurrentPosition(
      (pos) => resolve(toCoords(pos)),
      (err) => {
        // Timeout or position unavailable -> retry with low accuracy.
        if (err && (err.code === 3 || err.code === 2)) {
          tryLowAccuracy();
        } else {
          fail(err);
        }
      },
      { enableHighAccuracy: true, timeout: 12000, maximumAge: 30000 },
    );
  });
}
